"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseSocketService_1 = require("./BaseSocketService");
var UserNotificationsSocketService = /** @class */ (function (_super) {
    tslib_1.__extends(UserNotificationsSocketService, _super);
    function UserNotificationsSocketService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserNotificationsSocketService.prototype.onSocketError = function (err) {
        if (err === "unauthorized") {
            window.__sdk__.auth.logout();
        }
    };
    UserNotificationsSocketService.prototype.startListeningUserNotificationsCreated = function (fn) {
        this.socket.on("user_notifications_created", fn);
    };
    UserNotificationsSocketService.prototype.startListeningUserNotificationsMarkAsSeen = function (fn) {
        this.socket.on("user_notifications_mark_as_seen", fn);
    };
    UserNotificationsSocketService.prototype.startListeningUserNotificationsUpdated = function (fn) {
        this.socket.on("user_notifications_updated", fn);
    };
    UserNotificationsSocketService.prototype.getNotificationsById = function (userId) {
        return this.request("get_notifications_by_id", { userId: userId });
    };
    UserNotificationsSocketService.prototype.markAsSeen = function (notificationId) {
        return this.request("user_notifications_mark_as_seen", { notificationId: notificationId });
    };
    UserNotificationsSocketService.prototype.markAllAsSeen = function (userId) {
        return this.request("user_notifications_mark_all_as_seen", { userId: userId });
    };
    UserNotificationsSocketService.prototype.getNotificationsSettingsById = function (userId) {
        return this.request("get_notifications_settings_by_id", { userId: userId });
    };
    UserNotificationsSocketService.prototype.updateSetting = function (id, data) {
        return this.request("update_notifications_setting", { id: id, data: data });
    };
    UserNotificationsSocketService.prototype.deleteSetting = function (id) {
        return this.request("delete_setting", { id: id });
    };
    return UserNotificationsSocketService;
}(BaseSocketService_1.default));
exports.default = new UserNotificationsSocketService();
